import { useMessages2 } from "../../hooks/useLanguage"
import { formatPrice } from "../../view/suggested-price"
import styles from "./prices-card.module.css"

export const PricesCard = ({ pricesValue, currency }: { 
    pricesValue?: {
        leatherPrice: number
        fabricPrice: number
    },
    currency: string
}) => {
    const {messages} = useMessages2();

    return (
        <div className={styles.pricesCard}>
                <ul className={styles.pricesList}> 
                    <li> 
                        <span className={styles.title}>{messages?.overlay_starting_price}</span> 
                    </li>
                    { pricesValue && pricesValue.leatherPrice > 0 ?
                        <li className={styles.pricesItems}>
                            <span>{`${messages?.overlay_leader}`}</span> 
                            <span>{`${formatPrice(pricesValue?.leatherPrice || 0)}`} {currency.toUpperCase()}</span>
                        </li>
                        :
                        null
                    }
                    { pricesValue && pricesValue.fabricPrice > 0 ?
                        <li className={styles.pricesItems}>
                            <span>{`${messages?.overlay_fabric}`}</span> 
                            <span>{`${formatPrice(pricesValue?.fabricPrice || 0)}`} {currency.toUpperCase()}</span>
                        </li>
                        :
                        null
                    }
                </ul>
        </div>
    )
}